module.exports = __webpack_public_path__ + "media/images/front/doctorbook_logo-45e78d37df93b0eb2f948abf54c88f69.png";